import React from "react";
import CenterModal from "../../../mobilecomponent/CenterModal";
import { useTranslation } from "react-i18next";

const CanUseModal = ({ showCanUseModal }) => {
  const { t } = useTranslation();
  return (
    <CenterModal>
      <div className="text-center">
        <div>{t('CanUseModal_violatedRules', '귀하께서는 규정을 위반하여')}</div>
        <div>{t('CanUseModal_communityUsage', '커뮤니티 이용이')}</div>
        <div>{t('CanUseModal_blocked', '차단되었습니다.')}</div>
      </div>
      <span
        className="mt-[24px] block w-full border rounded border-[#1B5EDC] text-[#1B5EDC] bg-[#FAFCFF] text-center px-[36px] py-[20px] hover:bg-[#F2F6FC] hover:border-[#18428E] hover:text-[#18428E] ease-in-out duration-300 cursor-pointer"
        onClick={showCanUseModal}
      >
        {t('CanUseModal_confirm', '확인')}
      </span>
    </CenterModal>
  );
};

export default CanUseModal;
